<template>
  <Dialog :showHeader="false" :visible.sync="showDialog" :modal="true" :containerStyle="{width: '50vw'}">
    <div class="flex flex-col items-center py-6 px-4 h-auto"> <!-- Increased vertical padding for more height -->
      <h2 class="text-secondary font-bold text-3xl mb-6 leading-none">{{ title }}</h2> <!-- Increased margin-bottom for title -->
      <p class="text-center mb-6">{{ message }}</p> <!-- Increased margin-bottom for message -->
      <textarea
          v-if="requireReason"
          v-model="reason"
          class="border rounded bg-gray-100 border-gray-400 hover:border-primary focus:border-primary py-3 px-4 focus:shadow w-full mb-6"
          :placeholder="reasonPlaceholder"
          rows="3"
      ></textarea>
      <div class="flex w-full">
        <div class="w-1/2 px-2">
          <button
              @click="emitResult(false)"
              class="w-full flex items-center justify-center bg-red-200 hover:bg-red-300 text-secondary py-2 px-4 font-semibold rounded border border-red-400 hover:border-red-500 text-secondary hover:shadow active:shadow-inner transition duration-100"
          >
            <svg class="stroke-current h-5 w-5 mr-2" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
            <span>No</span>
          </button>
        </div>
        <div class="w-1/2 px-2">
          <button
              @click="emitResult(true)"
              :disabled="requireReason && !reason.trim()"
              class="w-full flex items-center justify-center bg-green-200 hover:bg-green-300 text-secondary py-2 px-4 font-semibold rounded border border-green-400 hover:border-green-500 text-secondary hover:shadow active:shadow-inner transition duration-100 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <svg class="stroke-current h-5 w-5 mr-2" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
              <path d="M20 6L9 17l-5-5"/>
            </svg>
            <span>Yes</span>
          </button>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: 'Are you sure you want to proceed?'
    },
    title: {
      type: String,
      default: 'Are you sure?'
    },
    requireReason: {
      type: Boolean,
      default: false
    },
    reasonPlaceholder: {
      type: String,
      default: 'Reason...'
    }
  },
  data() {
    return {
      showDialog: false,
      reason: '',
      resolvePromise: null
    };
  },
  methods: {
    open() {
      this.reason = '';
      this.showDialog = true;
      return new Promise((resolve) => {
        this.resolvePromise = resolve;
      });
    },
    close() {
      this.showDialog = false;
    },
    emitResult(result) {
      if (result && this.requireReason && !this.reason.trim()) {
        return;
      }
      const value = result ? (this.requireReason ? this.reason.trim() : true) : false;
      this.$emit('confirmed', value);
      this.close();
      if (this.resolvePromise) {
        this.resolvePromise(value);
        this.resolvePromise = null;
      }
    }
  }
};
</script>
